<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Reason Type {{ (reasonType.name) ? (" - " + reasonType.name) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4">View Reason Type - {{reasonType.name}}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Reason Type - {{reasonType.name}}</h6>
        
        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <div v-if="customFormMode == 1">
                <base-input alternative="" label="Code" placeholder="" v-model="reasonType.code" input-classes="form-control" />
                <base-input alternative="" label="Name" placeholder="" v-model="reasonType.name" input-classes="form-control" required />
                <base-input alternative="" label="Remark">
                    <textarea rows="4" class="form-control" v-model="reasonType.remark" />
                </base-input>

                <base-input label="Operation" required>
                    <a-select  v-model="reasonType.operation_type" :disabled="$attrs.viewMode">
                        <a-select-option v-for="option in operationOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                    </a-select>
                </base-input>

                <base-input label="Operation" required >
                    <select class="form-control" v-model="reasonType.operation_type" :disabled="$attrs.viewMode">
                        <option v-for="option in operationOptions" v-bind:value="option.key" v-bind:key="option.key">
                            {{ option.value }}
                        </option>
                    </select>
                </base-input> -->
            </div>

            <div v-if="customFormMode == 2">
                <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="reasonType" @valueUpdated="updateSettings" :key="dynamicFormKey"/>
            </div>

            <div v-if="customFormMode == 3">
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Basic" key="1">
                        <base-input alternative="" label="Code" placeholder="" v-model="reasonType.code" input-classes="form-control" />
                        <base-input alternative="" label="Name" placeholder="" v-model="reasonType.name" input-classes="form-control" required />
                        <base-input alternative="" label="Remark">
                            <textarea rows="4" class="form-control" v-model="reasonType.remark" />
                        </base-input>

                        <base-input label="Operation" required>
                            <a-select  v-model="reasonType.operation_type" :disabled="$attrs.viewMode">
                                <a-select-option v-for="option in operationOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                            </a-select>
                        </base-input>
                     
                        <base-input label="Operation" required >
                            <select class="form-control" v-model="reasonType.operation_type" :disabled="$attrs.viewMode">
                                <option v-for="option in operationOptions" v-bind:value="option.key" v-bind:key="option.key">
                                    {{ option.value }}
                                </option>
                            </select>
                        </base-input> -->
                    </a-tab-pane>
                    <a-tab-pane tab="Custom Fields" key="2" forceRender>
                        <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="reasonType" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                    </a-tab-pane>
                </a-tabs>
            </div>
            
            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button>
                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>
        </form>
    </div>
</template>


<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import { mapState } from 'vuex'
    import DynamicForm from '../DynamicForm.vue'

    var component_x;
    export default {
        components: {
            DynamicForm
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {

            // Meta-data Call
            const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Reason Type?field_name=name'  , null)
            const sytemModuleId = sytemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)
            if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
                const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
                if(accSystemModule != null){
                    if(accSystemModule.form_mode != undefined){
                        this.customFormMode = accSystemModule.form_mode
                    }
                    if(accSystemModule.customized_forms != undefined){
                        this.customForm = accSystemModule.customized_forms
                    }
                }
            }

            if(this.serverType == 'branch' || this.$attrs.viewMode == true){
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }
            component_x = this
            if (component_x.profileId > 0) {
                var reason_type_data = await HTTPRequest.getRequest(component_x.endPoint + 'reason_types/' + component_x.profileId, null)
                if (reason_type_data == undefined) {
                    component_x.$router.go()
                } else {
                    if (reason_type_data["error"] == undefined) {
                        component_x.reasonType = reason_type_data
                    } else {
                        this.errors = reason_type_data["error"].split(",")
                    }
                }
            }

            this.dynamicFormKey++;
        },
        data: function () {
            return {
                operationOptions: [
                    {value: "ABORT RECEIPT", key: "ABT"},
                    {value: "ITEM DISCOUNT", key: "DSC"},
                    {value: "LINE VOID", key: "LVD"},
                    {value: "VOID RECEIPT", key: "VOI"},
                    {value: "PRICE OVERRIDE", key: "OVD"},
                    {value: "TRANSACTIONAL PRICE CHANGE", key: "PLC"},
                    {value: "REPRINT OF RECEIPT", key: "PRN"},
                    {value: "RETURN", key: "RET"},
                    {value: "TAX CHANGE", key: "TAX"},
                    {value: "BARCODE PRINTING", key: "BCD"},
                    {value: "WITHDRAWAL", key: "WIT"},
                    {value: "DEPOSIT", key: "DEP"},
                    {value: "REFUND", key: "REF"},
                    {value: "CHANGE QUANTITY", key: "QTY"},                     
                    {value: "ON-US", key: "ONUS"},
                    {value: "MERGE TABLES", key: "MRG"},     
                    {value: "CHANGE PAYMENT", key: "CHPAY"},
                    {value: "Z-READING", key: "ZRD"},
                ],
                errors: [],
                // FOR META-DATA
                customFormMode: 1,
                customForm: {},
                profileData: {},
                dynamicFormKey: 0,
                reasonType: {
                    code: '',
                    name: ''
                },
                formErrors: []
            }
        },
        methods: {
            updateSettings(newFormSettings, settingsGrouping, errors){
                var formSettingsCopy = this.reasonType
                var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
                this.formErrors = errors

                if(this.customFormMode == 3) {
                    this.errors = errors
                }

                this.reasonType = mergedHash
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },

            validateForm(){
                this.errors = [];
                // this.errors.push(ValidateField.required('Code', this.reasonType.code));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Code', this.reasonType.code));
                this.errors.push(ValidateField.charMinAndMax('Code', this.reasonType.code, 0, 30));
                this.errors.push(ValidateField.required('Name', this.reasonType.name));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Name', this.reasonType.name));
                this.errors.push(ValidateField.charMinAndMax('Name', this.reasonType.name, 0, 50));
                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            create: async function () {
                if(!this.validateForm()) {
                    // var reason_typePayload = {
                    //     reason_type: {
                    //         name: this.inputName.trim(),
                    //         code: this.inputCode.trim(),
                    //         remark: this.inputRemark,
                    //         status: 'A',
                    //         operation_type: this.inputOperation
                    //     }
                    // }
                    this.reasonType.name = this.reasonType.name.trim()
                    this.reasonType.code = this.reasonType.code.trim()
                    this.reasonType.status = 'A'
                    var reason_typePayload = { reason_type: this.reasonType }

                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'reason_types', null, reason_typePayload)
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {
                    // var reason_typePayload = {
                    //     reason_type: {
                    //         name: this.inputName.trim(),
                    //         code: this.inputCode.trim(),
                    //         remark: this.inputRemark,
                    //         status: 'A',
                    //         operation_type: this.inputOperation
                    //     }
                    // }

                    this.reasonType.name = this.reasonType.name.trim()
                    this.reasonType.code = this.reasonType.code.trim()
                    let status = (this.reasonType.status == null) ?  "A" : this.reasonType.status
                    this.reasonType.status = status
                    // this.reasonType.status = 'A'
                    var reason_typePayload = { reason_type: this.reasonType }

                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'reason_types/' + this.profileId, null, reason_typePayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            }
        }
    }
</script>

<style>
</style>